module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat4-f2eac304e683c5f5dcaf27357febf007.svg";